// App.js
import React, { useState, useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import Navbar from "./modules/navbar";
import Footer from "./modules/footer";
import Home from "./modules/home";
import About from "./modules/about";
import Contact from "./modules/contact";
import ErrorPage from "./modules/error/index";
import PeriodicService from "./modules/services/periodic-service";
import DentingService from "./modules/services/dentingAndPainting";
import AcServices from "./modules/services/acServices";
import DetailingService from "./modules/services/detailingService";
import MajorCarService from "./modules/services/majorServices";
import CarSpaService from "./modules/services/carSpaservices";
import ClutchService from "./modules/services/clutchServices";
import TireService from "./modules/services/tireservices";
import WhatsAppButton from "./whatsAppBtn";
import LoadingDots from "./modules/initialLoad";

const AppLayout = () => {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    const isPageRefresh = performance.getEntriesByType("navigation")[0]?.type === "reload";

    if (isMobile && isPageRefresh && window.location.pathname !== "/") {
      window.location.replace("/");
    }
  }, []);

  return (
    <>
      {showAnimation ? (
        <LoadingDots />
      ) : (
        <>
          <WhatsAppButton />
          <Navbar />
          <Outlet />
          <Footer />
        </>
      )}
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: "/", element: <Home /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "services/periodic", element: <PeriodicService /> },
      { path: "services/denting", element: <DentingService /> },
      { path: "services/acservices", element: <AcServices /> },
      { path: "services/detailing", element: <DetailingService /> },
      { path: "services/major", element: <MajorCarService /> },
      { path: "services/carspa", element: <CarSpaService /> },
      { path: "services/clutch", element: <ClutchService /> },
      { path: "services/tire", element: <TireService /> },
    ],
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
